module.exports = "<!-- <p> User id = {{userId}}</p> -->\r\n<open-tok [userId]=\"userId\"></open-tok>"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/support/contact-support/contact-support.component.html
// module id = ../../../../../src/app/support/contact-support/contact-support.component.html
// module chunks = main